import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";

type Props = {
  label: string;
  value: string | number | null;
  lineClamp?: number;
};

export const Data = ({ label, value, lineClamp }: Props) => {
  const formatedValue = !value ? "-" : value;

  return (
    <Stack justify="flex-start" gap={0}>
      <Text fw={600} lh={"21px"} fz={"sm"} lineClamp={2}>
        {label}
      </Text>
      <Text fw={400} lh={"24px"} fz={"md"} lineClamp={lineClamp || 3}>
        {formatedValue}
      </Text>
    </Stack>
  );
};
